import React, { useState } from 'react';
import { includes, upperCase, filter } from 'lodash';

import FieldFilter from './FieldFilter';
import FieldSelector from './FieldSelector';
import { fieldTypes, ANY } from '../../../utils/report-builder';
import { createFieldGroups } from '../reducer';

const Sidebar = ({
  config,
  canClear,
  onToggleField,
  clearReport,
  onToggleFieldGroup
}) => {
  const [searchFilter, setSearchFilter] = useState(null);
  const [searchType, setSearchType] = useState(fieldTypes[ANY]);

  const onChangeSearchFilter = rawInput => {
    const fieldSearch = rawInput.replace(/[^0-9a-zA-Z-_ ]+/g, '');

    setSearchFilter(fieldSearch);
  };

  const onChangeFiltersFieldType = activeFieldType =>
    setSearchType(activeFieldType);

  const applyFilters = () =>
    filter(
      config.fields,
      field =>
        searchType.onFilter(field.fieldType) &&
        includes(upperCase(field.label), upperCase(searchFilter))
    );

  const getFieldSelectorGroups = () => {
    return createFieldGroups(applyFilters(), config.groups);
  };

  return (
    <div className="tvt-report-builder__sidebar-wrapper">
      <div className="tvt-report-builder__sidebar">
        <FieldFilter
          search={searchFilter}
          type={searchType}
          types={fieldTypes}
          onChangeSearch={onChangeSearchFilter}
          onChangeType={onChangeFiltersFieldType}
          clearFunc={clearReport}
          canClear={canClear}
        />
        {config && config.fields ? (
          <FieldSelector
            key="field-selector-report-builder"
            fields={getFieldSelectorGroups()}
            onToggleFieldGroup={onToggleFieldGroup}
            onToggleField={onToggleField}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Sidebar;
